import { render, staticRenderFns } from "./Assessment.vue?vue&type=template&id=acac82c4&scoped=true&"
import script from "./Assessment.vue?vue&type=script&lang=ts&"
export * from "./Assessment.vue?vue&type=script&lang=ts&"
import style0 from "./Assessment.vue?vue&type=style&index=0&id=acac82c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acac82c4",
  null
  
)

export default component.exports